import { useState, useEffect, Fragment } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput } from "../../base/CustomInputText";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import CustomRadioBtn from "../../base/CustomRadioBtn";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import { connectTypes, portTypes, ruleTypes } from "./SecurityGroupRuleData";
import CustomText from "components/base/CustomText";


interface ArgsType {
    securityGroupId: string;
}

interface SecurityGroupRuleAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType,
};

SecurityGroupRuleAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function SecurityGroupRuleAdd(props:SecurityGroupRuleAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);
    
    const [securityGroupDirectionType, setSecurityGroupDirectionType] = useState("IN");
    const [securityGroupRuleType, setSecurityGroupRuleType] = useState("CUSTTCP");
    
    const [minPort, setMinPort] = useState("");
    const [maxPort, setMaxPort] = useState("");
    const [openPortType, setOpenPortType] = useState("SINGLE");
    const [ipProtocol, setIpProtocol] = useState("");

    const [remoteType, setRemoteType] = useState("CIDR");
    const [remoteCidr, setRemoteCidr] = useState("");

    const [remoteSecurityGroupId, setRemoteSecurityGroupId] = useState("");
    const [securityGroupRuleTypeChangeYn, setSecurityGroupRuleTypeChangeYn] = useState(false);
    const [securityGroupList, setSecurityGroupList] = useState<DropdownType[]>([]);
    const [maxPortWarnYn, setMaxPortWarnYn] = useState(false);
    const [minPortWarnYn, setMinPortWarnYn] = useState(false);
    const [ipProtocolWarnYn, setIpProtocolWarnYn] = useState(false);
    const [remoteCidrWarnYn, setRemoteCidrWarnYn] = useState(false);


    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    
                }
            } else {
                const successYn = checkSecurityGroupRuleData();
                if(successYn) {
                    setExecuteAddYn(true);
                }
            }
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(executeAddYn) {
            executeAddSecurityGroupRule();
        }
    }, [executeAddYn]);

    useEffect(() => {
        if(securityGroupRuleTypeChangeYn) {
            setSecurityGroupRuleTypeChangeYn(false);
        }
    }, [securityGroupRuleTypeChangeYn]);

    useEffect(() => {
        setSecurityGroupRuleTypeChangeYn(true);
        if(securityGroupRuleType === "ALL" || securityGroupRuleType === "ALLTCP" || securityGroupRuleType === "ALLUDP" || securityGroupRuleType === "ALLICMP") {
            setOpenPortType('ALL');
            setMaxPort("");
            setMinPort("");
            setIpProtocol("");
        } else if(securityGroupRuleType === "CUSTTCP" || securityGroupRuleType === "CUSTUDP") {
            setOpenPortType('SINGLE');
            setMaxPort("");
            setMinPort("");
            setIpProtocol("");
        } else if(securityGroupRuleType === "CUSTICMP") {
            setOpenPortType('MULTI');
            setMaxPort("");
            setMinPort("");
            setIpProtocol("");
        } else if(securityGroupRuleType === "OTHER") {
            setOpenPortType('SINGLE');
            setMaxPort("");
            setMinPort("");
            setIpProtocol("");
        } else if(securityGroupRuleType === "DNS") {
            setOpenPortType('SINGLE');
            setMaxPort("53");
            setMinPort("53");
            setIpProtocol("");
        } else if(securityGroupRuleType === "HTTP") {
            setOpenPortType('SINGLE');
            setMaxPort("80");
            setMinPort("80");
            setIpProtocol("");
        } else if(securityGroupRuleType === "HTTPS") {
            setOpenPortType('SINGLE');
            setMaxPort("443");
            setMinPort("443");
            setIpProtocol("");
        } else if(securityGroupRuleType === "IMAP") {
            setOpenPortType('SINGLE');
            setMaxPort("143");
            setMinPort("143");
            setIpProtocol("");
        } else if(securityGroupRuleType === "IMAPS") {
            setOpenPortType('SINGLE');
            setMaxPort("993");
            setMinPort("993");
            setIpProtocol("");
        } else if(securityGroupRuleType === "MSSQL") {
            setOpenPortType('SINGLE');
            setMaxPort("1443");
            setMinPort("1443");
            setIpProtocol("");
        } else if(securityGroupRuleType === "MYSQL") {
            setOpenPortType('SINGLE');
            setMaxPort("3306");
            setMinPort("3306");
            setIpProtocol("");
        } else if(securityGroupRuleType === "POP3") {
            setOpenPortType('SINGLE');
            setMaxPort("110");
            setMinPort("110");
            setIpProtocol("");
        } else if(securityGroupRuleType === "POP3S") {
            setOpenPortType('SINGLE');
            setMaxPort("995");
            setMinPort("995");
            setIpProtocol("");
        } else if(securityGroupRuleType === "RDP") {
            setOpenPortType('SINGLE');
            setMaxPort("3390");
            setMinPort("3390");
            setIpProtocol("");
        } else if(securityGroupRuleType === "SMTP") {
            setOpenPortType('SINGLE');
            setMaxPort("25");
            setMinPort("25");
            setIpProtocol("");
        } else if(securityGroupRuleType === "SMTPS") {
            setOpenPortType('SINGLE');
            setMaxPort("465");
            setMinPort("465");
            setIpProtocol("");
        } else if(securityGroupRuleType === "SSH") {
            setOpenPortType('SINGLE');
            setMaxPort("22");
            setMinPort("22");
            setIpProtocol("");
        }
    }, [securityGroupRuleType]);

    useEffect(() => {
        if(remoteType === "SG") {
            loadSecurityGroupList();
        }
    }, [remoteType]);


    function loadSecurityGroupList() {
        requests.get(PLATFORM_URL.SECURITY_GROUP)
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setSecurityGroupList(response.data.items.map((data, index) => {
                    if(data.security_group_id === props.args?.securityGroupId) {
                        return false;
                    }
                    return { value: data.security_group_id, label: data.security_group_name };
                }).filter((v)=>{if(v !== false) return v}));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function checkSecurityGroupRuleData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setMinPortWarnYn(false);
        setMaxPortWarnYn(false);
        setIpProtocolWarnYn(false);
        setRemoteCidrWarnYn(false);
        let message = "";
        let error = false;
        if(securityGroupRuleType === "CUSTTCP" || securityGroupRuleType === "CUSTUDP") {
            if(openPortType === "SINGLE" || openPortType === "MULTI") {
                if(!minPort || isNaN(Number(minPort)) || Number(minPort) < 1) {
                    message = t("MESSAGE_SECURITY_GROUP_RULE_INFO_ENTER_ERROR_MESSAGE")
                    setMinPortWarnYn(true);
                    error = true;
                }
                if(openPortType === "MULTI") {
                    if(!maxPort || isNaN(Number(maxPort)) || Number(maxPort) < 1 || Number(minPort) > Number(maxPort)) {
                        message = t("MESSAGE_SECURITY_GROUP_RULE_INFO_ENTER_ERROR_MESSAGE")
                        setMaxPortWarnYn(true);
                        error = true;
                    }
                }
            }
        } else if(securityGroupRuleType === "CUSTICMP") {
            if(!minPort || isNaN(Number(minPort)) || (Number(minPort) < -1 || Number(minPort) > 255)) {
                message = t("MESSAGE_SECURITY_GROUP_RULE_INFO_ENTER_ERROR_MESSAGE")
                setMinPortWarnYn(true);
                error = true;
            }
            if(!maxPort || isNaN(Number(maxPort)) || (Number(maxPort) < -1 || Number(maxPort) > 255)) {
                message = t("MESSAGE_SECURITY_GROUP_RULE_INFO_ENTER_ERROR_MESSAGE")
                setMaxPortWarnYn(true);
                error = true;
            }
        } else if(securityGroupRuleType === "OTHER") {
            if(!ipProtocol || isNaN(Number(ipProtocol)) || Number(ipProtocol) < 0) {
                message = t("MESSAGE_SECURITY_GROUP_RULE_INFO_ENTER_ERROR_MESSAGE")
                setIpProtocolWarnYn(true);
                error = true;
            }
        }
        if(remoteType === 'SG' && !remoteSecurityGroupId) { 
            message = t("MESSAGE_SECURITY_GROUP_RULE_INFO_ENTER_ERROR_MESSAGE")
            error = true;
        }

        if(error === true) {
            executeResult({}, false, message);
        }
        
        return !error;
    }


    function executeAddSecurityGroupRule() {
        const addPackageData = {
            security_group_rule: {
                security_group_rule_type_code: securityGroupRuleType,
                direction_type_code: securityGroupDirectionType,
                open_port_type_code: openPortType,
                remote_type_code: remoteType
            },
            security_group: {
                security_group_id: props.args?.securityGroupId
            }
        };
        if(securityGroupRuleType === "CUSTTCP" || securityGroupRuleType === "CUSTUDP" || securityGroupRuleType === "CUSTICMP") {
            if(openPortType !== "ALL") {
                addPackageData['security_group_rule']['min_port'] = Number(minPort);
                if(openPortType === "MULTI") {
                    addPackageData['security_group_rule']['max_port'] = Number(maxPort);
                } else {
                    addPackageData['security_group_rule']['max_port'] = Number(minPort);
                }
            }
        }
        if(securityGroupRuleType === "OTHER") {
            addPackageData['security_group_rule']['ip_protocol'] = ipProtocol;       // ip_protocol = 4 : ipip
        }
        if(remoteType === "CIDR") {
            if(remoteCidr) {
                addPackageData['security_group_rule']['remote_cidr'] = remoteCidr;
            } else {
                addPackageData['security_group_rule']['remote_cidr'] = "0.0.0.0/0";
            }
        } else {
            addPackageData['remote_security_group'] = {};
            addPackageData['remote_security_group']['security_group_id'] = remoteSecurityGroupId;
        }
        requests.post(PLATFORM_URL.SECURITY_GROUP + '/' + props.args?.securityGroupId + '/rules', addPackageData)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_SECURITY_GROUP_RULE_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_SECURITY_GROUP_RULE_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }
    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }
    function selectButton(id, type){
        if(id === 'DirectionType') {
            setSecurityGroupDirectionType(type);
        }
    }    

    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("SECURITY_GROUP_RULE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("DIRECTION_TYPE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomRadioBtn
                                id={"DirectionType"} 
                                type={"IN"} 
                                size={18} 
                                checked={securityGroupDirectionType === "IN" ? true : false} 
                                selectCb={selectButton} 
                                label={"Inbound"}
                                labelStyle={labelStyle}
                            />
                            <View style={{width: 44}}/>
                            <CustomRadioBtn 
                                id={"DirectionType"} 
                                type={"OUT"} 
                                size={19} 
                                checked={securityGroupDirectionType === "OUT" ? true : false} 
                                selectCb={selectButton} 
                                label={"Outbound"}
                                labelStyle={labelStyle}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("SECURITY_GROUP_RULE_TYPE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={5} 
                                width={200} height={36} 
                                items={ruleTypes}
                                setValue={setSecurityGroupRuleType} 
                                disable={false}
                                defaultvalue={{label:"사용자 정의 TCP 규칙", value:"CUSTTCP"}}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                    {
                        securityGroupRuleTypeChangeYn === false ?
                        <Fragment>
                            {
                                securityGroupRuleType === "CUSTTCP" || securityGroupRuleType === "CUSTUDP" ?
                                <Fragment>
                                    <Text style={style.titleText}>{
                                        t("PORT_INFO_TEXT")}
                                    </Text>
                                    <View style={style.mainContainer}>
                                        <View style={style.rowContainer}>
                                            <CustomText text={t("PORT_TYPE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                            <CustomDropDown
                                                key={5} 
                                                width={200} height={36} 
                                                items={portTypes}
                                                setValue={setOpenPortType} 
                                                disable={securityGroupRuleType === "CUSTTCP" || securityGroupRuleType === "CUSTUDP" ? false : true}
                                                defaultvalue={{label:"단일 포트", value:"SINGLE"}}
                                            />
                                        </View>
                                        {
                                            openPortType !== "ALL" ?
                                            <View style={style.rowContainer}>
                                                <CustomText text={t("PORT_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                                <CustomTextInput 
                                                    key={6} 
                                                    width={100} height={36} 
                                                    value={minPort} 
                                                    type={"numer"} 
                                                    activeYn={openPortType === 'ALL' ? false : true} 
                                                    inputCb={(text)=>{
                                                        setMinPort(text)
                                                        openPortType === "SINGLE" && setMaxPort(text)
                                                    }} 
                                                    warnYn={minPortWarnYn} 
                                                    placeHolderText={t("ONLY_NUMBER_INPUT_TEXT")}
                                                />
                                                { openPortType === "MULTI" ?
                                                    <Fragment>
                                                        <Text style={{
                                                            marginLeft: 10, marginRight :10,
                                                            fontFamily: FONT.REGULAR,
                                                            fontSize: 13,
                                                            color: "#333"
                                                        }}>
                                                            ~
                                                        </Text>
                                                        <CustomTextInput 
                                                            key={7} 
                                                            width={100} height={36} 
                                                            value={maxPort} 
                                                            type={"numer"} 
                                                            activeYn={true} 
                                                            inputCb={setMaxPort} 
                                                            warnYn={maxPortWarnYn} 
                                                            placeHolderText={t("ONLY_NUMBER_INPUT_TEXT")}
                                                        />
                                                    </Fragment>
                                                    
                                                :null
                                                }
                                            </View>
                                            : null
                                        }
                                        <View style={style.rowDivContainer}/>
                                    </View>
                    
                                </Fragment>
                                : securityGroupRuleType === "CUSTICMP" ?
                                <Fragment>
                                    <Text style={style.titleText}>{
                                        t("PORT_INFO_TEXT")}
                                    </Text>
                                    <View style={style.mainContainer}>
                                        <View style={style.rowContainer}>
                                            <CustomText text={t("ICMP_TYPE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                            <CustomTextInput 
                                                key={126} 
                                                width={130} height={36} 
                                                value={minPort} 
                                                type={"numer"} 
                                                activeYn={true} 
                                                inputCb={(text)=>{setMinPort(text)}} 
                                                warnYn={minPortWarnYn} 
                                                placeHolderText={t("ONLY_NUMBER_INPUT_TEXT") + "(-1~255)"}
                                            />
                                            </View>
                                        <View style={style.rowContainer}>
                                            <CustomText text={t("ICMP_CODE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                            <CustomTextInput 
                                                key={127} 
                                                width={130} height={36} 
                                                value={maxPort} 
                                                type={"numer"} 
                                                activeYn={true} 
                                                inputCb={setMaxPort} 
                                                warnYn={maxPortWarnYn} 
                                                placeHolderText={t("ONLY_NUMBER_INPUT_TEXT") + "(-1~255)"}
                                            />
                                        </View>
                                        <View style={style.rowDivContainer}/>
                                    </View>
                                </Fragment>
                                : securityGroupRuleType === "OTHER" ?
                                <Fragment>
                                    <Text style={style.titleText}>{
                                        t("PORT_INFO_TEXT")}
                                    </Text>
                                    <View style={style.mainContainer}>
                                        <View style={style.rowContainer}>
                                            <CustomText text={t("IP_PROTOCOL_NUMBER_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                            <CustomTextInput 
                                                key={96} 
                                                width={100} height={36} 
                                                value={minPort} 
                                                type={"numer"} 
                                                activeYn={securityGroupRuleType === "OTHER" ? true : false} 
                                                inputCb={(text)=>{
                                                    setIpProtocol(text)
                                                    setMinPort("");
                                                    setMaxPort("");
                                                }} 
                                                warnYn={ipProtocolWarnYn} 
                                                placeHolderText={t("ONLY_NUMBER_INPUT_TEXT")}
                                            />
                                        </View>
                                    </View>
                                    <View style={style.rowDivContainer}/>
                                </Fragment>
                                :null
                            }
                        </Fragment>
                        :securityGroupRuleType === "OTHER" ? 
                        <Fragment>
                            
                        </Fragment>
                        :null
                    }
                    <Text style={style.titleText}>{
                        t("SECURITY_GROUP_RULE_CONNECT_ALLOW_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("SECURITY_GROUP_RULE_CONNECT_TYPE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={8} 
                                width={200} height={36} 
                                items={connectTypes}
                                setValue={setRemoteType} 
                                disable={false}
                                defaultvalue={{label:"CIDR", value:"CIDR"}}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            {remoteType === "CIDR" ?
                                <Fragment>
                                    <Text style={style.columnText}>
                                        {t("CIDR_TEXT")}
                                    </Text>
                                    <CustomTextInput 
                                        key={9} 
                                        width={400} height={36} 
                                        value={remoteCidr} 
                                        type={"text"} 
                                        activeYn={true} 
                                        inputCb={setRemoteCidr} 
                                        warnYn={remoteCidrWarnYn} 
                                        placeHolderText={"0.0.0.0/0"}
                                    />
                                </Fragment>
                            :
                                <Fragment>
                                    <CustomText text={t("SECURITY_GROUP_OTHER_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                    <CustomDropDown
                                        key={10} 
                                        width={300} height={36} 
                                        items={securityGroupList}
                                        setValue={setRemoteSecurityGroupId} 
                                        disable={false}
                                        defaultvalue={{label:"", value:""}}
                                    />
                                </Fragment>
                            }
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
});

const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}